import * as React from 'react';
import { Button as AntdButton } from 'antd';
import PropTypes from 'prop-types';

import './Button.css';

const propTypes = {
  outline: PropTypes.any,
  background: PropTypes.any,
  className: PropTypes.any,
  name: PropTypes.any,
  onClick: PropTypes.any,
  disabled: PropTypes.any,
  children: PropTypes.any
};

function Button(props) {
  let componentClasses = 'Button ';
  if (props.outline) {
    componentClasses += `Button__outline Button__outline--${props.outline}`;
  } else {
    componentClasses += `bg-${props.background || 'primary'} Button__hover--${props.background ||
      'primary'}`;
  }

  componentClasses += ` ${props.className || 'text-xl'}`;
  return (
    <AntdButton
      name={props.name}
      data-test={props.name}
      data-unit={props.name}
      onClick={props.onClick}
      htmlType="submit"
      className={componentClasses}
      disabled={props.disabled}>
      {props.children}
    </AntdButton>
  );
}

Button.propTypes = propTypes;

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/Button.jsx